import type { ApiError } from 'modules/global/generic.types';
import type { Nullable } from 'modules/global/typing/common/common';
import { createReducer } from 'utils/ReduxUtils';

import type { WrapperReducerConfig } from './reducers.types';
import { isStartRequest, isFailureRequest } from './utils';

/**
 * The error slice of a request: `null` while it is in flight, the failure action's payload once it
 * fails. That payload is whatever the dispatcher put there — the raw {@link ApiError} for a failure
 * generated by `simpleRequest`, a translation key for the modules that dispatch their failure by
 * hand — hence the type parameter. Pass it explicitly (`error<string>(...)`) when the slice holds a
 * message key.
 * @template E the shape of the error the module dispatches
 */
const error = <E = ApiError>(
  actionRoot: string,
  { reducers = {}, matchers = [], global: config }: WrapperReducerConfig<Nullable<E>> = {}
) =>
    createReducer<Nullable<E>>(null, reducers, [
      {
        matcher: isStartRequest(actionRoot, config),
        reducer: () => null,
      },
      {
        matcher: isFailureRequest(actionRoot, config),
        reducer: (_: Nullable<E>, { payload }: { payload: E }) => payload,
      },
      ...matchers,
    ]);

export default error;
